export enum LoaderValues {
	animationDuration = 1.2,
	react2Delay = 0.1,
	react3Delay = 0.2,
	react4Delay = 0.3,
	react5Delay = 0.4
}
